import React, { useCallback, useContext } from 'react'
import { tournamentTypes } from '../cnr/reducers/SportsTournamentReducer'
import { playoffBracketTypes } from '../elements/matches/PlayoffBracket'
import { CreatePlayoffContext } from '../create/CreatePlayoff'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'

export const usePlayoffSchedule = ({ tournamentType }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { playoff_info: playoff_info_season } = sportsSeason_state ?? {}
  const { playoffTournaments } = playoff_info_season ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_matchInfo } = createPlayoff_state ?? {}
  const { tournaments: tournaments_playoff } = playoff_matchInfo ?? {}

  const tournaments = tournaments_playoff || playoffTournaments

  const getPoolsAndRounds = useCallback(({ tournamentItem, item_round }) => {
    return get_poolsAndRounds(tournaments, tournamentItem, tournamentType, item_round)
  }, [tournaments])

  return { getPoolsAndRounds }

}

const get_poolsAndRounds = (tournaments, tournamentItem, tournamentType, item_round) => {
  if (_.isEmpty(tournaments)) { return { rounds: {}, poolz: [] } }
  switch (tournamentType) {
    case tournamentTypes.existingPlayoff:
      const rt = item_round || 'playoffs'
      const tournament = tournamentItem ? tournaments[tournamentItem] : Object.values(tournaments)[0]
      const { rounds: rounds_t } = tournament ?? {}
      const round_t = rounds_t?.[rt] || null
      const { pools: pools_t } = round_t ?? {}
      const poolz1 = getPoolz(pools_t)
      return { rounds: rounds_t, poolz: poolz1 }

    default:
      const t = tournamentItem ? tournaments[tournamentItem] : Object.values(tournaments)[0]
      const { rounds } = t ?? {}
      const round = rounds ? Object.values(rounds)[0] : {}
      const { pools } = round ?? {}
      const poolz2 = getPoolz(pools)
      return { rounds, poolz: poolz2 }
  }
}

const getPoolz = (pools) => {
  const poolz = []
  if (pools && pools.roundOf32) { poolz.push(playoffBracketTypes.roundOf32) }
  if (pools && pools.roundOf16) { poolz.push(playoffBracketTypes.roundOf16) }
  if (pools && pools.quarterFinals) { poolz.push(playoffBracketTypes.quarterFinals) }
  if (pools && pools.semiFinals) { poolz.push(playoffBracketTypes.semiFinals) }
  if (pools && pools.finals) { poolz.push(playoffBracketTypes.finals) }
  return poolz
}